import React from 'react';

const WhyChooseUs = () => {
  const benefits = [
    {
      icon: "https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80",
      title: 'No Repairs Needed',
      description: 'We buy Dallas houses in any condition. As-is, no fixes required.'
    },
    {
      icon: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80",
      title: 'No Commissions',
      description: 'Keep 100% of the cash offer. No agent fees or hidden costs.'
    },
    {
      icon: "https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80",
      title: 'Fast Closings',
      description: 'Close in as little as 7 days or choose your own timeline.'
    },
    {
      icon: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80",
      title: 'Locally Owned',
      description: 'Proudly serving Dallas homeowners. Your neighbors, not outsiders.'
    },
    {
      icon: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&h=100&q=80",
      title: 'Trustworthy',
      description: 'Transparent, honest, and professional service every time.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-propwhiz-dark mb-4">
            Why Dallas Homeowners Choose PropWhiz
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We make selling your Dallas home simple, fast, and stress-free. Here's why homeowners trust us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 group"
            >
              <div className="mb-6 relative">
                <img 
                  src={benefit.icon} 
                  alt={benefit.title}
                  className="w-20 h-20 rounded-2xl object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-propwhiz-accent/10 rounded-2xl"></div>
              </div>
              <h3 className="text-2xl font-bold text-propwhiz-dark mb-3">{benefit.title}</h3>
              <p className="text-gray-600">{benefit.description}</p>
            </div>
          ))}
        </div>

        {/* Dallas Trust Badge */}
        <div className="mt-16 bg-gradient-to-r from-propwhiz-blue to-propwhiz-accent rounded-3xl p-8 text-white text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            {/* <img 
              src="https://images.unsplash.com/photo-1631603090981-8e16d7a0c1f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=50&h=50&q=80" 
              alt="Dallas Trust" 
              className="w-12 h-12 rounded-full border-2 border-white"
            /> */}
            <h3 className="text-2xl font-bold">Trusted by Dallas Homeowners Since 2020</h3>
          </div>
          <p className="text-lg opacity-90">Join hundreds of satisfied Dallas sellers who chose PropWhiz</p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;